import axios from "axios";

const DEFAULT_API_BASE = "http://localhost:5001/api";

const resolveApiBase = () => {
  const configured = (process.env.REACT_APP_API_BASE_URL || "").trim();
  const fallback = DEFAULT_API_BASE;
  const base = configured || fallback;

  if (typeof window === "undefined") return base;

  try {
    const url = new URL(base);
    const isLocalHost =
      url.hostname === "localhost" || url.hostname === "127.0.0.1";
    const currentHost = window.location.hostname;
    const usingRemoteHost = currentHost && currentHost !== "localhost" && currentHost !== "127.0.0.1";
    if (isLocalHost && usingRemoteHost) {
      url.hostname = currentHost;
      return url.toString().replace(/\/$/, "");
    }
    return url.toString().replace(/\/$/, "");
  } catch {
    return base;
  }
};

export const API_BASE = resolveApiBase();
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const api = axios.create({
  baseURL: API_BASE
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** Drop every trace of the stored admin session. */
export const clearStoredSession = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_user");
};

// Endpoints whose 401s are meaningful to the caller and must not trigger a
// redirect: a bad password on /auth/login should surface as a form error, and
// /auth/me is handled inside AuthContext so it can sign out via React state
// instead of a full page reload.
const SELF_HANDLED_401_PATHS = ["/auth/login", "/auth/me"];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestPath = error?.config?.url || "";
    const isSelfHandled = SELF_HANDLED_401_PATHS.some((path) => requestPath.includes(path));

    // An expired or revoked token used to leave the portal in a half-broken
    // state that only clearing site data could fix. Now it recovers itself.
    if (status === 401 && !isSelfHandled) {
      clearStoredSession();
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default api;
